import { Box, Typography } from "@mui/material";
import styles from "../../screens/PostSearch/PostRequirement.module.css";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
const SalesRecruiter = ({
  image,
  name,
  skill,
  location,
  status,
  btn1,
  btn2,
}) => {
  const navigate = useNavigate()

  const buttonColor = btn2 === "Viewed" ? "#4285f4" : "#3856a6";
  return (
    <Box
      className={styles.recruiter_job_post}
      sx={{ border: "1px solid #f5f5f5" }}
    >
      <Box>
        <img src={image} alt="" />
        <span>
          <Typography>
            Candidate Name: <b>{name}</b>
          </Typography>
          <Typography>
            Job Profile: <b>{skill}</b>
          </Typography>
          <Typography>
            Location: <b>{location}</b>
          </Typography>
          <Typography sx={{ margin: "0 !important" }}>
            Visa: <b>{status}</b>
          </Typography>
        </span>

      </Box>

      <Box sx={{alignItems:'center', flexDirection:'column'}}>

        <span
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "5px",
            justifyContent: 'space-between'
          }}
        >
          <Typography>
            <PiFileTextLight fontSize="26px" /> <b>Resume</b>
          </Typography>
          <Typography sx={{ marginLeft: "15px" }}>
            <PiFilesLight fontSize="26px" /> <b>Documents</b>
          </Typography>
        </span>

        <button
         onClick={() => navigate('/bench-view')}
          style={{ backgroundColor: buttonColor, alignSelf: "flex-end" }}
        >
          {btn2}
        </button>
      </Box>
    </Box>
  );
};

export default SalesRecruiter;
